import { RouteComponentProps } from "react-router-dom";
import { Button } from "@patternfly/react-core";
import styled from "styled-components";
import { useState } from "react";
import Get from "../../components/Get";
import ContainerAlertReport from "./ContainerAlertReport";

const S = {
	Page: styled.div`
      margin-top: -15px;
      @media screen {
        height: 100%;
        background: #333638;
        max-width: 100vw;
        width: 100%;
        overflow-x: scroll;
      }
    `,
	Button: styled(Button)`
      bottom: 24px;
      right: 24px;
      position: fixed;
      z-index: 100;

      @media print {
        display: none
      }
    `,
	LanguageButton: styled(Button)`
      bottom: 80px;
      right: 24px;
      position: fixed;
      z-index: 100;

      @media print {
        display: none
      }
    `,
};

interface ContainerType {
	id: number;
	containerNumber: string;
	seenAt: string;
	location: string;
	trailerPlate: string;
	truckPlate: string;
	photos: Array<{ id: number; file: string }>;
	intelligence: string;
	vehiclePlates: string[];
	plateLookupResults?: Array<{
		plate: string;
		smviu: { vehicleId: number; stolenStatus: string } | null;
		rdw: { status: "found" | "not-found" };
	}>;
}

const ContainerReportView = (props: RouteComponentProps<{ id: string }>) => {
	const { id } = props.match.params;
	const [language, setLanguage] = useState<"en" | "nl" | "fr">("en");

	const cycleLanguage = () => {
		const languages: Array<"en" | "nl" | "fr"> = ["en", "nl", "fr"];
		const currentIndex = languages.indexOf(language);
		const nextIndex = (currentIndex + 1) % languages.length;
		setLanguage(languages[nextIndex]);
	};

	const getLanguageLabel = () => {
		const labels = { en: "EN", nl: "NL", fr: "FR" };
		return labels[language];
	};

	return (
		<S.Page>
			<S.LanguageButton onClick={cycleLanguage}>
				Language: {getLanguageLabel()}
			</S.LanguageButton>

			<S.Button onClick={window.print}>Print / Download</S.Button>

			<Get url={`/containers/${id}/`}>
				{({ data }: { data: ContainerType }) => (
					<ContainerAlertReport container={data} language={language} />
				)}
			</Get>
		</S.Page>
	);
};

export default ContainerReportView;
